import React from 'react';

const Loading = () => {
    return (
        <div className="preloader" id="preloader">
            <div className="la-ball-scale-multiple la-2x">
                <div></div>
                <div></div>
                <div></div>
            </div>
        </div>
    );
};

export default Loading;